import { Component, input, computed } from "@angular/core";
import { IBaseCard, isJobsBillingCard, isT1Card } from "@app/views-interfaces";
import { AppLoaderComponent } from "../../shared/components/app-loader/app-loader.component";
import { CardJobsBillingComponent } from "../../card-components/card-jobs-billing-component/card-jobs-billing.component";
import { CardT1Component } from "../../card-components/card-t1-component/card-t1.component";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "wk-search-result",
    templateUrl: "./search-result.component.html",
    styleUrl: "./search-result.component.scss",
    host: { class: "wk-search-result fancy-scrollbar" },
    imports: [AppLoaderComponent, CardJobsBillingComponent, CardT1Component, TranslatePipe],
})
export class SearchResultComponent {
    public cards = input<IBaseCard[]>([]);
    protected showLoader = input<boolean>(false);
    protected searchTerm = input<string>("");
    protected readonly isJobsBillingCard = isJobsBillingCard;
    protected readonly isT1Card = isT1Card;

    protected readonly cardMatchedFields = computed(() => {
        const cards = this.cards();
        const term = this.searchTerm().toLowerCase();

        if (!term) return new Map<string, string>();

        const matchMap = new Map<string, string>();

        cards.forEach((card) => {
            const matchedField = this.findMatchedField(card, term);
            if (matchedField) {
                matchMap.set(card.cardId, matchedField);
            }
        });

        return matchMap;
    });

    private findMatchedField(card: IBaseCard, searchTerm: string): string | null {
        const fieldsToCheck: { key: string; value: string | null | undefined | number }[] = [
            { key: "cardId", value: card.cardId },
            { key: "firstName", value: card.contactInformation?.firstName },
            { key: "lastName", value: card.contactInformation?.lastName },
            { key: "name", value: card.name },
            { key: "email", value: card.contactInformation?.email },
            { key: "phone", value: card.contactInformation?.phone },
            { key: "cellPhone", value: card.contactInformation?.cellPhone },
        ];
        if (isJobsBillingCard(card)) {
            fieldsToCheck.push({ key: "jobId", value: card.job?.id }, { key: "clientCode", value: card.contactInformation?.clientCode });
        }
        if (isT1Card(card)) {
            const clientCodeValue = card.clientCodes?.clientCodeId || card.clientCodes?.clientCodePIN || card.clientCodes?.clientCodeiFirm;
            fieldsToCheck.push({ key: "clientCode", value: clientCodeValue });
        }

        for (const field of fieldsToCheck) {
            if (field.value && String(field.value).toLowerCase().includes(searchTerm)) {
                return field.key;
            }
        }

        return null;
    }

    protected getMatchedFieldForCard(cardId: string): string {
        return this.cardMatchedFields().get(cardId) || "";
    }
}
